import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CONTACTS_SPLIT_PATTERN } from '../../../campaign-wizard/campaign-wizard.service';
import {
	AlarisDropdownComponent,
	AlarisDropdownDirective,
	AlarisIconDirective,
	SelectDropdownPositions,
} from '@campaign-portal/components-library';
import { ReactiveFormsModule } from '@angular/forms';
import { ConnectedPosition } from '@angular/cdk/overlay';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'app-campaign-plain-contacts',
	standalone: true,
	imports: [
		AlarisDropdownDirective,
		AlarisDropdownComponent,
		AlarisIconDirective,
		TranslateModule,
		ReactiveFormsModule,
	],
	templateUrl: './campaign-plain-contacts.component.html',
	styleUrl: './campaign-plain-contacts.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CampaignPlainContactsComponent implements OnChanges {
	@Input() text = '';
	@Input() code: number | null = null;

	readonly maxVisibleContacts = 100;
	readonly positions: ConnectedPosition[] = SelectDropdownPositions;

	contacts: string[] = [];
	_opened = false;

	constructor() {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.text) {
			this.contacts = this.text.split(CONTACTS_SPLIT_PATTERN);
		}
	}
}
